import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { FeatureFlagRoute } from '@/components/feature-flag-route'
import FeatureFlags from '@/config/feature-flags'
import LazyRoute from '../components/LazyRoute'

const searchSchema = z.object({
  source_id: z.string().optional(),
})

export const Route = createFileRoute('/_protected/connection-builder/$id')({
  component: () => (
    <FeatureFlagRoute flag={FeatureFlags.WEBHOOK_ROUTING}>
      <LazyRoute
        loader={() => import('@/components/pages/BridgeBuilder')}
        fallback={
          <div className="p-8 text-center">Loading Connection Builder...</div>
        }
      />
    </FeatureFlagRoute>
  ),
  validateSearch: searchSchema,
})